import {
  getPreviewModeAPI,
  postPreviewModeAPI,
  putPreviewModeAPI,
  deletePreviewModeAPI,
} from "../api";

export default {
  namespaced: true,

  state: {
    data: {
      previewModes: [],
      isLoading: false,
    },
  },

  getters: {
    getPreviewModes: (state) => state.data.previewModes,
    getLoading: (state) => state.data.isLoading,
  },

  actions: {
    actionGetPreviewModes({ commit, rootState }) {
      const { env } = rootState.selectEnv.data;
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        getPreviewModeAPI(env).then(
          (response) => {
            commit("SET_PREVIEW_MODE", response);
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            resolve(response);
          },
          (error) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            reject(error);
          }
        );
      });
    },

    actionSetPreviewMode({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      if (payload && !payload.eventKey) {
        return new Promise((resolve, reject) => {
          postPreviewModeAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      } else {
        return new Promise((resolve, reject) => {
          putPreviewModeAPI(payload)
            .then((res) => {
              resolve(res);
            })
            .catch((err) => {
              setTimeout(() => {
                commit("SET_IS_LOADING", false);
              }, 1000);
              console.log("err: ", err);
              reject(err);
            });
        });
      }
    },

    actionDeletePreviewMode({ commit }, payload) {
      commit("SET_IS_LOADING", true);
      return new Promise((resolve, reject) => {
        deletePreviewModeAPI(payload)
          .then((res) => {
            resolve(res);
          })
          .catch((err) => {
            setTimeout(() => {
              commit("SET_IS_LOADING", false);
            }, 1000);
            console.log("err: ", err);
            reject(err);
          });
      });
    },
  },

  mutations: {
    SET_PREVIEW_MODE(state, payload) {
      state.data.previewModes = payload;
    },
    SET_IS_LOADING(state, payload) {
      state.data.isLoading = payload;
    },
  },
};
